"use client";

import { Trophy } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface VysledkyHeaderProps {
  nazov: string;
  pocetVysledkov: number;
  pocetRegistrovanych: number;
}

const HEADER_CONTAINER_CLASSES = "text-center space-y-6";
const BADGE_CONTAINER_CLASSES = cn(
  "inline-flex items-center gap-2",
  "px-4 py-2 bg-linear-to-r from-brand-gradient-from to-brand-gradient-to",
  "text-primary-foreground rounded-full shadow-md",
);
const TITLE_CLASSES = cn(
  "text-4xl lg:text-6xl font-bold",
  "bg-linear-to-r from-brand-gradient-from to-brand-gradient-to",
  "bg-clip-text text-transparent",
);
const STAT_CARD_CLASSES =
  "text-center p-4 bg-background/50 rounded-xl border shadow-sm min-w-[120px]";

export function VysledkyHeader({
  nazov,
  pocetVysledkov,
  pocetRegistrovanych,
}: VysledkyHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className={HEADER_CONTAINER_CLASSES}
    >
      <div className={BADGE_CONTAINER_CLASSES}>
        <Trophy className="h-5 w-5" />
        <span className="font-semibold text-sm uppercase tracking-wider">
          Olympijská nominácia 2026
        </span>
      </div>
      <h1 className={TITLE_CLASSES}>{nazov}</h1>
      <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
        Voľba fanúšikov o nominácii slovenskej hokejovej
        reprezentácie na ZOH 2026 v Miláne
      </p>
      <div className="flex flex-wrap justify-center gap-4 md:gap-8">
        <div
          className={cn(
            STAT_CARD_CLASSES,
            "bg-status-info/5 border-status-info/10",
          )}
        >
          <div className="text-3xl md:text-4xl font-bold text-status-info">
            {pocetRegistrovanych}
          </div>
          <div className="text-xs text-muted-foreground uppercase font-bold tracking-widest mt-1">
            Registrovaných
          </div>
        </div>
        <div
          className={cn(
            STAT_CARD_CLASSES,
            "bg-status-success/5 border-status-success/10",
          )}
        >
          <div className="text-3xl md:text-4xl font-bold text-status-success">
            {pocetVysledkov}
          </div>
          <div className="text-xs text-muted-foreground uppercase font-bold tracking-widest mt-1">
            Hlasov
          </div>
        </div>
      </div>
    </motion.div>
  );
}
